/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../../../widgets/livewidget/nls/StringResources',
	'../impl/SmartsRecommenderFeature',
	'./api/VisualizationSmartsRecommenderAPI',
	'./api/DeprecatedVisualizationSmartsRecommenderAPI'
], function (APIFactory, resources, SmartsRecommenderFeature, SmartsRecommenderAPI, DeprecatedSmartsRecommenderAPI) {
	'use strict';

	class VisualizationSmartsRecommender extends SmartsRecommenderFeature {

		constructor(options) {
			super(options);
			this.creationTransactionToken = options.transactionToken;
			this.visualization = options.features['Visualization'];
			this.modelsInternal = options.features['Models.internal'];
			this.liveWidgetSegment = options.features['LiveWidgetSegment'];
			this._api = APIFactory.createAPI(this, [SmartsRecommenderAPI]);
			this._dashboardAPI = this.features['Dashboard.API'];
			this._deprecatedAPI = APIFactory.createAPI(this, [DeprecatedSmartsRecommenderAPI]);

			this._dashboardAPI.on('shapingmodel:changed', this.clearRecommenderCache, this);

		}

		initialize() {
			if (!this.visualization.getType()) {
				return this.recommendBestVisualization(this.creationTransactionToken);
			}
		}

		destroy() {
			this._dashboardAPI.off('shapingmodel:changed', this.clearRecommenderCache, this);

			super.destroy();
			this.creationTransactionToken = null;
			this.visualization = null;
			this.modelsInternal = null;
			this._api = null;
			this._deprecatedAPI = null;
		}

		getAPI(type) {
			if (type === 'deprecated'){
				return this._deprecatedAPI;
			}

			return this._api;
		}

		clearRecommenderCache() {
			super.clearRecommenderCache();
		}

		getRecommendedVisualizations(){
			return super.getRecommendedVisualizations(this.visualization).then(recommended => {
				// include the automatic recommendation along with the recommended visualizations
				return [{
					id: SmartsRecommenderAPI.AUTO_ID,
					caption: resources.get('automaticTypeCaption'),
					icon: 'visualizations-changeVisualization',
					disabled: recommended.length === 0
				}, ...recommended];
			});
		}

		getRecommendedTitle() {
			return super.getRecommendedTitle(this.visualization) ;
		}

		setType(type, transactionToken){
			return type === SmartsRecommenderAPI.AUTO_ID ? super.recommendBestVisualization(this.visualization, transactionToken) : super.setType(this.visualization, type, transactionToken);
		}

		addDataItems(dataItemSpecList, transactionToken) {
			return super.addDataItems(this.visualization, dataItemSpecList, transactionToken) ;
		}

		recommendBestVisualization(transactionToken) {
			return super.recommendBestVisualization(this.visualization, transactionToken);
		}

		// deprecated interface -- called by explore
		recommendAlternateVisualizationsAsWidgetSpecs() {
			return super.recommendAlternateVisualizationsAsWidgetSpecs(this.visualization, JSON.parse(JSON.stringify(this.modelsInternal.getWidgetModel().toJSON())));
		}

		// deprecated interface -- called by explore
		recommendRelatedVisualizationsAsWidgetSpecs() {
			return super.recommendRelatedVisualizationsAsWidgetSpecs(this.visualization, JSON.parse(JSON.stringify(this.modelsInternal.getWidgetModel().toJSON())));
		}

		recommendCompareVisualizationsAsWidgetSpecs() {
			return super.recommendCompareVisualizationsAsWidgetSpecs(this.visualization, JSON.parse(JSON.stringify(this.modelsInternal.getWidgetModel().toJSON())));
		}
	}

	return VisualizationSmartsRecommender;
});
